module.exports = __webpack_public_path__ + "img/replay.5070664c.svg";